"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _anagni = _interopRequireDefault(require("./26_group_2024_01_31/anagni"));

var _anguillaraSabazia = _interopRequireDefault(require("./26_group_2024_01_31/anguillara-sabazia"));

var _anteySaintAndre = _interopRequireDefault(require("./26_group_2024_01_31/antey-saint-andre"));

var _arpino = _interopRequireDefault(require("./26_group_2024_01_31/arpino"));

var _barzano = _interopRequireDefault(require("./26_group_2024_01_31/barzano"));

var _baschi = _interopRequireDefault(require("./26_group_2024_01_31/baschi"));

var _bellinzagoLombardo = _interopRequireDefault(require("./26_group_2024_01_31/bellinzago-lombardo"));

var _belluno = _interopRequireDefault(require("./26_group_2024_01_31/belluno"));

var _bonifati = _interopRequireDefault(require("./26_group_2024_01_31/bonifati"));

var _borghettoLodigiano = _interopRequireDefault(require("./26_group_2024_01_31/borghetto-lodigiano"));

var _borgoValsugana = _interopRequireDefault(require("./26_group_2024_01_31/borgo-valsugana"));

var _bovilleErnica = _interopRequireDefault(require("./26_group_2024_01_31/boville-ernica"));

var _bralloDiPregola = _interopRequireDefault(require("./26_group_2024_01_31/brallo-di-pregola"));

var _bressanaBottarone = _interopRequireDefault(require("./26_group_2024_01_31/bressana-bottarone"));

var _busca = _interopRequireDefault(require("./26_group_2024_01_31/busca"));

var _cagli = _interopRequireDefault(require("./26_group_2024_01_31/cagli"));

var _caiazzo = _interopRequireDefault(require("./26_group_2024_01_31/caiazzo"));

var _campli = _interopRequireDefault(require("./26_group_2024_01_31/campli"));

var _cannetoPavese = _interopRequireDefault(require("./26_group_2024_01_31/canneto-pavese"));

var _capolona = _interopRequireDefault(require("./26_group_2024_01_31/capolona"));

var _cassolnovo = _interopRequireDefault(require("./26_group_2024_01_31/cassolnovo"));

var _castelDelPiano = _interopRequireDefault(require("./26_group_2024_01_31/castel-del-piano"));

var _castelfrancoPiandisco = _interopRequireDefault(require("./26_group_2024_01_31/castelfranco-piandisco"));

var _castellabate = _interopRequireDefault(require("./26_group_2024_01_31/castellabate"));

var _castellettoDiBranduzzo = _interopRequireDefault(require("./26_group_2024_01_31/castelletto-di-branduzzo"));

var _castellinaInChianti = _interopRequireDefault(require("./26_group_2024_01_31/castellina-in-chianti"));

var _cavaManara = _interopRequireDefault(require("./26_group_2024_01_31/cava-manara"));

var _cavriglia = _interopRequireDefault(require("./26_group_2024_01_31/cavriglia"));

var _cervaro = _interopRequireDefault(require("./26_group_2024_01_31/cervaro"));

var _corbetta = _interopRequireDefault(require("./26_group_2024_01_31/corbetta"));

var _crespinaLorenzana = _interopRequireDefault(require("./26_group_2024_01_31/crespina-lorenzana"));

var _curaCarpignano = _interopRequireDefault(require("./26_group_2024_01_31/cura-carpignano"));

var _fabro = _interopRequireDefault(require("./26_group_2024_01_31/fabro"));

var _ficulle = _interopRequireDefault(require("./26_group_2024_01_31/ficulle"));

var _filottrano = _interopRequireDefault(require("./26_group_2024_01_31/filottrano"));

var _gaioleInChianti = _interopRequireDefault(require("./26_group_2024_01_31/gaiole-in-chianti"));

var _garlasco = _interopRequireDefault(require("./26_group_2024_01_31/garlasco"));

var _gessate = _interopRequireDefault(require("./26_group_2024_01_31/gessate"));

var _giussago = _interopRequireDefault(require("./26_group_2024_01_31/giussago"));

var _gualdoCattaneo = _interopRequireDefault(require("./26_group_2024_01_31/gualdo-cattaneo"));

var _inveruno = _interopRequireDefault(require("./26_group_2024_01_31/inveruno"));

var _lAquila = _interopRequireDefault(require("./26_group_2024_01_31/l-aquila"));

var _lacchiarella = _interopRequireDefault(require("./26_group_2024_01_31/lacchiarella"));

var _linarolo = _interopRequireDefault(require("./26_group_2024_01_31/linarolo"));

var _loroCiuffenna = _interopRequireDefault(require("./26_group_2024_01_31/loro-ciuffenna"));

var _maglianoInToscana = _interopRequireDefault(require("./26_group_2024_01_31/magliano-in-toscana"));

var _massaECozzile = _interopRequireDefault(require("./26_group_2024_01_31/massa-e-cozzile"));

var _merate = _interopRequireDefault(require("./26_group_2024_01_31/merate"));

var _miradoloTerme = _interopRequireDefault(require("./26_group_2024_01_31/miradolo-terme"));

var _monteSanGiovanniCampano = _interopRequireDefault(require("./26_group_2024_01_31/monte-san-giovanni-campano"));

var _monteSanSavino = _interopRequireDefault(require("./26_group_2024_01_31/monte-san-savino"));

var _montecassiano = _interopRequireDefault(require("./26_group_2024_01_31/montecassiano"));

var _montecatiniValDiCecina = _interopRequireDefault(require("./26_group_2024_01_31/montecatini-val-di-cecina"));

var _montesarchio = _interopRequireDefault(require("./26_group_2024_01_31/montesarchio"));

var _montuBeccaria = _interopRequireDefault(require("./26_group_2024_01_31/montu-beccaria"));

var _morazzone = _interopRequireDefault(require("./26_group_2024_01_31/morazzone"));

var _mulazzo = _interopRequireDefault(require("./26_group_2024_01_31/mulazzo"));

var _panicale = _interopRequireDefault(require("./26_group_2024_01_31/panicale"));

var _passignanoSulTrasimeno = _interopRequireDefault(require("./26_group_2024_01_31/passignano-sul-trasimeno"));

var _perdifumo = _interopRequireDefault(require("./26_group_2024_01_31/perdifumo"));

var _peschieraBorromeo = _interopRequireDefault(require("./26_group_2024_01_31/peschiera-borromeo"));

var _pieveEmanuele = _interopRequireDefault(require("./26_group_2024_01_31/pieve-emanuele"));

var _pievePortoMorone = _interopRequireDefault(require("./26_group_2024_01_31/pieve-porto-morone"));

var _reggello = _interopRequireDefault(require("./26_group_2024_01_31/reggello"));

var _rodano = _interopRequireDefault(require("./26_group_2024_01_31/rodano"));

var _roeVolciano = _interopRequireDefault(require("./26_group_2024_01_31/roe-volciano"));

var _saintVincent = _interopRequireDefault(require("./26_group_2024_01_31/saint-vincent"));

var _sambucaPistoiese = _interopRequireDefault(require("./26_group_2024_01_31/sambuca-pistoiese"));

var _sanBenedettoPo = _interopRequireDefault(require("./26_group_2024_01_31/san-benedetto-po"));

var _sanCostanzo = _interopRequireDefault(require("./26_group_2024_01_31/san-costanzo"));

var _sanGimignano = _interopRequireDefault(require("./26_group_2024_01_31/san-gimignano"));

var _sanMartinoValleCaudina = _interopRequireDefault(require("./26_group_2024_01_31/san-martino-valle-caudina"));

var _sanVendemiano = _interopRequireDefault(require("./26_group_2024_01_31/san-vendemiano"));

var _santAgataDeGoti = _interopRequireDefault(require("./26_group_2024_01_31/sant-agata-de-goti"));

var _santEgidioAllaVibrata = _interopRequireDefault(require("./26_group_2024_01_31/sant-egidio-alla-vibrata"));

var _santaGiuletta = _interopRequireDefault(require("./26_group_2024_01_31/santa-giuletta"));

var _santaMariaDellaVersa = _interopRequireDefault(require("./26_group_2024_01_31/santa-maria-della-versa"));

var _savignone = _interopRequireDefault(require("./26_group_2024_01_31/savignone"));

var _scarlino = _interopRequireDefault(require("./26_group_2024_01_31/scarlino"));

var _scarperiaESanPiero = _interopRequireDefault(require("./26_group_2024_01_31/scarperia-e-san-piero"));

var _sermoneta = _interopRequireDefault(require("./26_group_2024_01_31/sermoneta"));

var _serraSanQuirico = _interopRequireDefault(require("./26_group_2024_01_31/serra-san-quirico"));

var _serrone = _interopRequireDefault(require("./26_group_2024_01_31/serrone"));

var _sestino = _interopRequireDefault(require("./26_group_2024_01_31/sestino"));

var _seveso = _interopRequireDefault(require("./26_group_2024_01_31/seveso"));

var _sezze = _interopRequireDefault(require("./26_group_2024_01_31/sezze"));

var _solaro = _interopRequireDefault(require("./26_group_2024_01_31/solaro"));

var _sorano = _interopRequireDefault(require("./26_group_2024_01_31/sorano"));

var _spessa = _interopRequireDefault(require("./26_group_2024_01_31/spessa"));

var _stella = _interopRequireDefault(require("./26_group_2024_01_31/stella"));

var _torchiara = _interopRequireDefault(require("./26_group_2024_01_31/torchiara"));

var _torreDIsola = _interopRequireDefault(require("./26_group_2024_01_31/torre-d-isola"));

var _torrevecchiaPia = _interopRequireDefault(require("./26_group_2024_01_31/torrevecchia-pia"));

var _toscolanoMaderno = _interopRequireDefault(require("./26_group_2024_01_31/toscolano-maderno"));

var _travacoSiccomario = _interopRequireDefault(require("./26_group_2024_01_31/travaco-siccomario"));

var _tresana = _interopRequireDefault(require("./26_group_2024_01_31/tresana"));

var _valleve = _interopRequireDefault(require("./26_group_2024_01_31/valleve"));

var _viadana = _interopRequireDefault(require("./26_group_2024_01_31/viadana"));

var _vistarino = _interopRequireDefault(require("./26_group_2024_01_31/vistarino"));

var _zianoPiacentino = _interopRequireDefault(require("./26_group_2024_01_31/ziano-piacentino"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = _objectSpread({}, _anagni["default"], {}, _anguillaraSabazia["default"], {}, _anteySaintAndre["default"], {}, _arpino["default"], {}, _barzano["default"], {}, _baschi["default"], {}, _bellinzagoLombardo["default"], {}, _belluno["default"], {}, _bonifati["default"], {}, _borghettoLodigiano["default"], {}, _borgoValsugana["default"], {}, _bovilleErnica["default"], {}, _bralloDiPregola["default"], {}, _bressanaBottarone["default"], {}, _busca["default"], {}, _cagli["default"], {}, _caiazzo["default"], {}, _campli["default"], {}, _cannetoPavese["default"], {}, _capolona["default"], {}, _cassolnovo["default"], {}, _castelDelPiano["default"], {}, _castelfrancoPiandisco["default"], {}, _castellabate["default"], {}, _castellettoDiBranduzzo["default"], {}, _castellinaInChianti["default"], {}, _cavaManara["default"], {}, _cavriglia["default"], {}, _cervaro["default"], {}, _corbetta["default"], {}, _crespinaLorenzana["default"], {}, _curaCarpignano["default"], {}, _fabro["default"], {}, _ficulle["default"], {}, _filottrano["default"], {}, _gaioleInChianti["default"], {}, _garlasco["default"], {}, _gessate["default"], {}, _giussago["default"], {}, _gualdoCattaneo["default"], {}, _inveruno["default"], {}, _lAquila["default"], {}, _lacchiarella["default"], {}, _linarolo["default"], {}, _loroCiuffenna["default"], {}, _maglianoInToscana["default"], {}, _massaECozzile["default"], {}, _merate["default"], {}, _miradoloTerme["default"], {}, _monteSanGiovanniCampano["default"], {}, _monteSanSavino["default"], {}, _montecassiano["default"], {}, _montecatiniValDiCecina["default"], {}, _montesarchio["default"], {}, _montuBeccaria["default"], {}, _morazzone["default"], {}, _mulazzo["default"], {}, _panicale["default"], {}, _passignanoSulTrasimeno["default"], {}, _perdifumo["default"], {}, _peschieraBorromeo["default"], {}, _pieveEmanuele["default"], {}, _pievePortoMorone["default"], {}, _reggello["default"], {}, _rodano["default"], {}, _roeVolciano["default"], {}, _saintVincent["default"], {}, _sambucaPistoiese["default"], {}, _sanBenedettoPo["default"], {}, _sanCostanzo["default"], {}, _sanGimignano["default"], {}, _sanMartinoValleCaudina["default"], {}, _sanVendemiano["default"], {}, _santAgataDeGoti["default"], {}, _santEgidioAllaVibrata["default"], {}, _santaGiuletta["default"], {}, _santaMariaDellaVersa["default"], {}, _savignone["default"], {}, _scarlino["default"], {}, _scarperiaESanPiero["default"], {}, _sermoneta["default"], {}, _serraSanQuirico["default"], {}, _serrone["default"], {}, _sestino["default"], {}, _seveso["default"], {}, _sezze["default"], {}, _solaro["default"], {}, _sorano["default"], {}, _spessa["default"], {}, _stella["default"], {}, _torchiara["default"], {}, _torreDIsola["default"], {}, _torrevecchiaPia["default"], {}, _toscolanoMaderno["default"], {}, _travacoSiccomario["default"], {}, _tresana["default"], {}, _valleve["default"], {}, _viadana["default"], {}, _vistarino["default"], {}, _zianoPiacentino["default"]);

exports["default"] = _default;